/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/* eslint-disable no-restricted-syntax */

// events to notify changes to the widget

export const CONTINUE_SHOPPING_EVENT = 'CONTINUE_SHOPPING_EVENT';
export const MODIFY_RESERVATION_EVENT = 'MODIFY_RESERVATION_EVENT';

export const MESSAGE_EVENTS = {
    [CONTINUE_SHOPPING_EVENT]: {
        type: CONTINUE_SHOPPING_EVENT,
        description: 'continue shopping event',
    },
    [MODIFY_RESERVATION_EVENT]: {
        type: MODIFY_RESERVATION_EVENT,
        description: 'modify reservation event',
    },
};

export const TRUSTED_ORIGINS = [
    'http://localhost:9900',
    'https://www.r1s-dev.com',
    'https://www.r1s-test.com',
    'https://www.recreation.gov',
    'https://cdn.r1s-dev.com',
    'https://cdn.r1s-test.com',
    'https://cdn.recreation.gov',
    'https://www.nps.gov',
    'https://www.blm.gov',
    'https://www.fs.usda.gov',
    'https://www.usace.army.mil',
    'https://corpslakes.erdc.dren.mil',
];

/**
 * ********************************************************
 * Service Now API Versions
 * ********************************************************
 */

/**
 * Populates the conte of a single article (type = article, location-spotlight, journal)
 * @url /version/content/type/id
 */
export const ARTICLE_VERSION = 'g_ba2';

/**
 * Populates the articles on the Article Landing page, 9 per page (limit = Max 9, and offset = 0, 9, 18, 27...)
 * @url /version/content/all?offset=0&limit=9
 */
export const ARTICLES_VERSION = 'g_ba2';

/**
 * Populates the featured article at the top of the Article Landing page
 * @url /version/content/featured
 */
export const FEATURED_VERSION = 'g_ba2';

/**
 * Populates the 10 articles on the Homepage
 * @url /version/content/homepage
 */
export const HOMEPAGE_FEATURED_VERSION = 'g_ba2';
